import { OrderOrigin } from '../../interfaces/OrderOrigin'
import {
  GET_ORDERORIGINS_EXITO,
  GET_ORDERORIGINS
} from '../types/orderOriginActionsTypes'

export type OrderOriginAction = OrderOriginsAction | OrderOriginsActionAsync

// Esto va a REDUX
export interface OrderOriginsAction {
  type: typeof GET_ORDERORIGINS_EXITO
  orderOrigins: OrderOrigin[] | undefined
  error: string | undefined
}

export const getOrderOriginsAction = (
  orderOrigins?: OrderOrigin[],
  error?: string
): OrderOriginsAction => {
  return {
    type: GET_ORDERORIGINS_EXITO,
    orderOrigins: orderOrigins,
    error
  }
}

// Esto va a SAGA
export interface OrderOriginsActionAsync {
  type: typeof GET_ORDERORIGINS
}

export const getOrderOriginsActionAsync = (): OrderOriginsActionAsync => {
  return {
    type: GET_ORDERORIGINS
  }
}
